import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay, take } from 'rxjs/operators';

import { ErrorService } from '@digital-platform/shared/services';
import { SigningLink } from '@digital-platform/sign-now/domain';
import { SignaturesService } from './signatures.service';

@Injectable({
  providedIn: 'root',
})
export class SignaturesFacadeService {
  public signingLink$: Observable<SigningLink | null>;
  public signedDocLink$: Observable<SigningLink | null>;
  public pdfLink$: Observable<SigningLink | null>;

  private notifier: BehaviorSubject<SigningLink | null>;

  public loading$: Observable<boolean>;
  private loadingNotifier: BehaviorSubject<boolean>;
  public isChangeInSignature = false;

  constructor(
    private service: SignaturesService,
    private readonly errorService: ErrorService
  ) {
    this.notifier = new BehaviorSubject<SigningLink | null>(null);
    this.loadingNotifier = new BehaviorSubject<boolean>(false);

    this.signingLink$ = this.notifier.asObservable();
    this.signedDocLink$ = this.notifier.asObservable();
    this.pdfLink$ = this.notifier.asObservable();
    this.loading$ = this.loadingNotifier.asObservable();
  }

  public getSignedDocLink(wasteProfileId: string) {
    this.loadingNotifier.next(true);
    this.service
      .getSignedDocLink(wasteProfileId)
      .pipe(take(1))
      .subscribe(
        (signedDocLink) => {
          this.notifier.next(signedDocLink);
          this.loadingNotifier.next(false);
        },
        (error) => {
          this.errorService.raiseError(error);
          this.loadingNotifier.next(false);
        }
      );
  }

  public getPdf(docType: string, dataItemId: string): Promise<void> {
    this.loadingNotifier.next(true);

    const serviceCall = this.service
      .getPdf(docType, dataItemId)
      .pipe(take(1), shareReplay());

    serviceCall.subscribe(
      (pdfLink) => {
        this.notifier.next(pdfLink);
        this.loadingNotifier.next(false);
      },
      (error) => {
        this.errorService.raiseError(error);
        this.loadingNotifier.next(false);
      }
    );

    return serviceCall.toPromise().then(() => {
      // no-op
    });
  }

  setvalue(val: boolean) {
    this.isChangeInSignature = val;
  }
  getvalue() {
    return this.isChangeInSignature;
  }
}
